import React, {
	useState
}from 'react'
import {
	Modal, Button, Form, Select, Row, Col
}from 'antd'
import {
	useSelector
}from 'react-redux'
import moment from 'moment'

import './style.css'
import CustomButton from '../../../components/ButtonCustom'
import {
	CustomSelect
}from '../../../components/CustomSelect'
const {
	Option
} = Select

const serverUrl = process.env.NODE_ENV === 'development'
	? process.env.SERVER_API_URL
	: `${ window.location.origin }/api`

const PdfFastReportAppeal = ({
	code, id = 0
}) => {
	const token = JSON.parse(window.localStorage.getItem('user')).token

	const createMarkup = () => {
		return {
			__html: `<iframe height="1000" width="900" src="${ serverUrl }/Report/DisplayAppealReport?code=${ code }`
      + `&id=${ id }&token=${ token }" / >`
		}
	}

	const getReport = () => {
		return (
			<div dangerouslySetInnerHTML={ createMarkup() } />
		)
	}

	return (
		<div>
			{ getReport() }
		</div>
	)
}

const DownloadAppeal = ({
	i18n, isRu, reOrgAppeal, fromControlSubsystem = false
}) => {
	const user = useSelector((state) => state.userReducer.user)

	const [visibleChange, setVisibleChange] = useState(false)
	const [values, setValues] = useState(null)

	const handleCancelChange = e => {
		setVisibleChange(false)
		setValues(null)
	}

	const handlerSave = values => {
		setValues(values)
	}

	return (
		<>
			<div
				className="download_appeal"
			>
				<svg
					className="download_appeal-icon"
					height="20"
					viewBox="0 0 20 20"
					width="20"
					xmlns="http://www.w3.org/2000/svg"
					onClick={ () => setVisibleChange(true) }
				>
					<path
						d="M9.46001 12.8317L5.4496 8.82248C5.30776 8.67895 5.22847 8.48512 5.22906 8.28333C5.22964 8.08154 5.31005 7.88817 5.45272 7.74546C5.59539 7.60276 5.78873 7.5223 5.99053 7.52166C6.19232 7.52102 6.38616 7.60025 6.52974 7.74205L9.23619 10.4477V1.59714C9.23619 1.39454 9.31667 1.20025 9.45993 1.05699C9.60319 0.913733 9.79749 0.833252 10.0001 0.833252C10.2027 0.833252 10.397 0.913733 10.5402 1.05699C10.6835 1.20025 10.764 1.39454 10.764 1.59714V10.4477L13.4704 7.74205C13.614 7.60025 13.8078 7.52102 14.0096 7.52166C14.2114 7.5223 14.4048 7.60276 14.5474 7.74546C14.6901 7.88817 14.7705 8.08154 14.7711 8.28333C14.7717 8.48512 14.6924 8.67895 14.5506 8.82248L10.5402 12.8317C10.3969 12.975 10.2026 13.0554 10.0001 13.0554C9.79753 13.0554 9.60326 12.975 9.46001 12.8317ZM19.1667 17.6388V12.2916C19.1667 12.089 19.0863 11.8947 18.943 11.7514C18.7998 11.6082 18.6055 11.5277 18.4029 11.5277C18.2003 11.5277 18.006 11.6082 17.8627 11.7514C17.7195 11.8947 17.639 12.089 17.639 12.2916V17.6388H2.36119V12.2916C2.36119 12.089 2.28071 11.8947 2.13746 11.7514C1.9942 11.6082 1.7999 11.5277 1.59731 11.5277C1.39471 11.5277 1.20041 11.6082 1.05715 11.7514C0.913897 11.8947 0.833416 12.089 0.833416 12.2916V17.6388C0.833872 18.0439 0.99498 18.4322 1.28139 18.7186C1.56781 19.005 1.95614 19.1661 2.36119 19.1666H17.639C18.044 19.1661 18.4324 19.005 18.7188 18.7186C19.0052 18.4322 19.1663 18.0439 19.1667 17.6388Z"
					/>
				</svg>

			</div>
			<Modal
				destroyOnClose
				className="unload-appeal-modal"
				footer={ null }

				/*
				 * footer={ [
				 * 	<Button
				 * 		key="submit"
				 * 		type="primary"
				 * 		onClick={ handleOkChange }
				 * 	>
				 * 		{ isRu ? 'Закрыть' : 'Закрыць' }
				 * 	</Button>
				 * ] }
				 */
				title={ i18n.downloadAppeal[isRu] }

				visible={ visibleChange }

				// width={ 1260 }
				onCancel={ handleCancelChange }
			>
				<Row justify="center">
					<Form
						className="unload-appeal-form"
						initialValues={ {
							['code']: -1
						} }
						labelAlign="left"
						onFinish={ handlerSave }
					>
						<Row
							className="unload-form-row"
							justify="center"
						>
							<Col
								lg={ { span: 14 } }
								md={ { span: 16 } }
								xl={ { span: 12 } }
							>
								<Form.Item
									className="unload-form-item"
									label={ isRu ? 'Отчет' : 'Справаздача' }
									labelCol={ { span: 6 } }
									name="code"
								>
									<CustomSelect
										className="unload-appeal-select"
										onChange={ () => setValues(null) }
									>
										<Select.Option value={ -1 }>
											{ isRu ? 'Обращение' : 'Зварот' }
										</Select.Option>
										{
											(user.reOrg?.id === reOrgAppeal.reOrg?.id 
											|| user.id === reOrgAppeal?.appeal?.creatorId
											|| fromControlSubsystem)&& [
												'11',
												'13',
												'14',
												'16'
											].includes(reOrgAppeal.status.code) ?
												(<Select.Option value={ -2 }>
													{ isRu ? 'Ответ на обращение' : 'Адказ на зварот' }
												</Select.Option>)
												:
												null
										}

									</CustomSelect>
								</Form.Item>
							</Col>
							<Col span={ 6 }>
								<Form.Item>
									<CustomButton
										className="unload-appeal-button"
										htmlType="submit"
										type="orange"
									>
										{ isRu ? 'Сгенерировать отчет' : 'Згенераваць справаздачу' }
									</CustomButton>
								</Form.Item>
							</Col>
						</Row>
						{ /* <Form.Item
						wrapperCol={ {
							span   : 12,
							offset : 6
						} }
					>
					</Form.Item> */ }
					</Form>
					<Col>
						{
							values ? (<PdfFastReportAppeal
								code={ values.code }
								id={ reOrgAppeal.id }
							          />) : null
						}
					</Col>
				</Row>
			</Modal>
		</>
	)
}

export default DownloadAppeal